// @flow

export const TABLE_ROW_HEIGHT = 36;
export const TABLE_BOTTOM_OFFSET = 72;
export const DEFAULT_COLUMN_WIDTH = 250;
export const MINIMAL_COLUMN_WIDTH = 180;
export const INDEX_COLUMN_WIDTH = 80;
export const LAST_COLUMN_RIGHT_OFFSET = 100;
